import React from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";


function FacebookAdvertisingAgency() {
  return (
    <>
      <Helmet>
        <title>Facebook Advertising Agency Ajman, Sharjah, Fujairah, Dubai, UAE</title>
        <meta name="description" content={"Looking for a trusted Facebook advertising agency in Dubai? As an advertising expert, we create high-performing Facebook ad campaigns that drive measurable business growth."} />
        <meta name="keywords" content={"facebook advertising agency dubai,facebook advertising agency abu dhabi,facebook advertising agency sharjah,facebook advertising agency ajman,facebook advertising agency fujairah,facebook advertising agency uae "} />
        <link rel="canonical" href={"https://www.websiteseo.ae/facebook-advertising-agency"} />
        <script type="application/ld+json">
          {JSON.stringify({
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "Websiteseo",
  "url": "https://www.websiteseo.ae/",
  "logo": {
    "@type": "ImageObject",
    "url": "https://www.websiteseo.ae/images/img/logo.png"
  },
  "description": "WebsiteSEO is a digital solutions agency offering website design and development, SEO, mobile app development, domain registration, web hosting, social media marketing, email marketing, SMS marketing, branding, and online marketing services to help businesses build and strengthen their digital presence.",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Office# 114 Al Ahbabi Building Damascus Street, Al Qusais Dubai, United Arab Emirates",
    "addressLocality": "Dubai",
    "addressRegion": "Dubai",
    "postalCode": "00000",
    "addressCountry": "UAE"
  },
  "contactPoint": [
    {
      "@type": "ContactPoint",
      "telephone": "+971 55 570 9788",
      "contactType": "customer service",
      "email": "sales@websiteseo.ae"
    }
  ]
})}
        </script>
      </Helmet>

<div>
  {/* HEADER
  ============================================= */}
  {/* END HEADER */}
  {/* HERO
  ============================================= */}
  <div className="inner-page-banner-wrap" style={{backgroundImage: 'url(/legacy/images/img/inner-banner-bg.jpg)', backgroundSize: 'cover', backgroundAttachment: 'fixed'}}>
    <div className="container">
      <h3>Facebook Advertising Agency</h3>
      <ul>
        <li><Link to="/">Home</Link></li>
        <li>Facebook Advertising Agency</li>
      </ul>
    </div>
  </div>
  <section style={{width: '100%', height: 200}}>
    <h1 style={{fontSize: 24, marginTop: 40, marginLeft: 70}}>Facebook Advertising Agency Abu Dhabi, Ajman, Sharjah, Fujairah, Dubai, UAE</h1>
  </section>
  {/* FOOTER
  ============================================= */}
  {/* END FOOTER */}
</div>

    </>
  );
}

export default FacebookAdvertisingAgency;
